import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {ProductType} from "../../../model/enums/ProductType.enum";

@Component({
  selector: 'v-product-infobox',
  templateUrl: './product-infobox.component.html',
  styleUrls: ['./product-infobox.component.scss']
})
export class ProductInfoboxComponent {
  @Input() type;
  @Input() site;
  @Input() sites;
  @Input() shoppingBenefits;
  @Input() availability;
  @Output() scrollTo: EventEmitter<HTMLElement> = new EventEmitter();
  productType = ProductType;
  visioncareURL = 'https://visionexpress.pl/promocje/subskrypcja-all-inclusive/';
  tooltipActive = false;

  goto(element) {
    this.scrollTo.emit(element);
  }
}
